<template>
  <div class="molded-seat-step-eight">
    <v-layout
      class="mb-8"
      justify-space-between
    >
      <v-flex sm5>
        <h3 class="mb-3">
          SEGMENTS PEDIEUX :
        </h3>

        <v-layout justify-space-between>
          <v-flex sm6>
            <v-select
              v-model="form.pedal_segment_module.right"
              :items="pedalSegmentModule.right"
              item-text="label"
              item-value="value"
              label="Droit"
              filled
              clearable
              hide-details
              @click:clear="
                $nextTick(() => (form.pedal_segment_module.right = null))
              "
            />
          </v-flex>
          <v-flex sm6>
            <v-select
              v-model="form.pedal_segment_module.left"
              :items="pedalSegmentModule.right"
              item-text="label"
              item-value="value"
              label="Gauche"
              filled
              clearable
              hide-details
              @click:clear="
                $nextTick(() => (form.pedal_segment_module.left = null))
              "
            />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        column
        sm6
      >
        <p>Schéma</p>
        <div class="content img1">
          <div class="img-container">
            <img src="@/assets/img/schema_verticalisateur_1a.svg">
            <v-text-field
              v-model="form.pedal_segment_module.a"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Segments Pedieux) A') }"
              data-vv-name="(Segments Pedieux) A"
              outlined
              type="number"
              style="top: 17.6%;left: 0.2%;"
              height="100%"
            />

            <v-text-field
              v-model="form.pedal_segment_module.b"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Segments Pedieux) B') }"
              data-vv-name="(Segments Pedieux) B"
              outlined
              type="number"
              style="top: 67.5%;left: 38.3%;"
              height="100%"
            />

            <v-text-field
              v-model="form.pedal_segment_module.c"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Segments Pedieux) C') }"
              data-vv-name="(Segments Pedieux) C"
              outlined
              type="number"
              style="top: 61.8%;left: 83.7%;"
              height="100%"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout
      class="mb-8"
      justify-space-between
    >
      <v-flex sm6>
        <v-switch
          v-model="form.footrest_module.idc_footrest"
          hide-details
          label="Repose-Pieds :"
          class="title"
          @change="clearFootrestFields"
        />

        <v-layout>
          <v-radio-group
            v-model="form.footrest_module.exist"
            hide-details
            row
            :disabled="!form.footrest_module.idc_footrest"
          >
            <v-radio
              class="mb-2"
              label="Existant"
              value="EXISTING"
            />
            <v-radio
              class="mb-2"
              label="Sur mesure"
              value="CUSTOM_MADE"
            />
          </v-radio-group>

          <v-radio-group
            v-model="form.footrest_module.form"
            hide-details
            row
            :disabled="!form.footrest_module.idc_footrest"
          >
            <v-radio
              class="mb-2"
              label="Carré"
              value="SQUARE"
            />
            <v-radio
              class="mb-2"
              label="Plat"
              value="FLAT"
            />
          </v-radio-group>

          <v-radio-group
            v-model="form.footrest_module.position"
            hide-details
            row
            :disabled="!form.footrest_module.idc_footrest"
          >
            <v-radio
              class="mb-2"
              label="Sur socle"
              value="SOCLE"
            />
            <v-radio
              class="mb-2"
              label="Sur châssis"
              value="CHASSIS"
            />
          </v-radio-group>
        </v-layout>
      </v-flex>

      <v-flex sm6>
        <h3>ARTICULATION</h3>
        <v-layout wrap>
          <v-flex>
            <v-checkbox
              v-model="form.footrest_module.idc_knees"
              class="mb-0 mt-2"
              label="Genoux"
              hide-details
            />
            <v-checkbox
              v-model="form.footrest_module.idc_ankles"
              class="mb-2 mt-0"
              label="Chevilles"
              hide-details
            />
          </v-flex>
          <v-flex>
            <v-checkbox
              v-model="form.footrest_module.idc_foldable"
              class="mb-0 mt-2"
              label="Rabattable"
              hide-details
            />
            <v-checkbox
              v-model="form.footrest_module.idc_separated"
              class="mb-2 mt-0"
              label="Séparé"
              hide-details
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <h3>RETOUR :</h3>

    <v-flex
      sm5
      mb-12
    >
      <v-layout
        class="checkbox-input-container"
        mt-0
      >
        <v-flex sm5>
          <v-checkbox
            v-model="form.footrest_module.idc_right"
            label="Droite"
            hide-details
          />
        </v-flex>
        <v-flex class="checkbox-input visible">
          <v-text-field
            v-model="form.footrest_module.right"
            v-validate="'numeric|max:4'"
            :class="{ error: errors.has('(Retour) Droite') }"
            data-vv-name="(Retour) Droite"
            type="number"
            outlined
          />
        </v-flex>
      </v-layout>
      <v-layout
        class="checkbox-input-container"
        mt-0
      >
        <v-flex sm5>
          <v-checkbox
            v-model="form.footrest_module.idc_left"
            label="Gauche"
            hide-details
          />
        </v-flex>
        <v-flex class="checkbox-input visible">
          <v-text-field
            v-model="form.footrest_module.left"
            v-validate="'numeric|max:4'"
            :class="{ error: errors.has('(Retour) Gauche') }"
            data-vv-name="(Retour) Gauche"
            type="number"
            outlined
          />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-layout
      class="mb-8"
      wrap
      justify-space-between
    >
      <v-flex sm4>
        <v-text-field
          v-model="form.footrest_module.leg_length"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('(Retour) Longueur jambes') }"
          data-vv-name="(Retour) Longueur jambes"
          class="mb-3"
          label="Longueur jambes"
          type="number"
          outlined
        />
      </v-flex>
      <v-flex sm4>
        <v-text-field
          v-model="form.footrest_module.legrest_angle"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('(Retour) Angle repose-jambe') }"
          data-vv-name="(Retour) Angle repose-jambe"
          label="Angle repose-jambe (°)"
          type="number"
          outlined
        />
      </v-flex>
      <v-flex sm4>
        <v-text-field
          v-model="form.footrest_module.foot_finishing"
          label="Finition pied"
          hide-details
          outlined
          maxlength="25"
        />
      </v-flex>
      <v-flex sm4 />
      <v-flex sm4>
        <v-text-field
          v-model="form.footrest_module.footrest_angle"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('(Retour) Angle repose-pieds') }"
          data-vv-name="(Retour) Angle repose-pieds"
          class="mb-3"
          label="Angle repose-pieds (°)"
          type="number"
          outlined
        />
      </v-flex>
      <v-flex sm4>
        <v-text-field
          v-model="form.footrest_module.calf_finishing"
          label="Finition mollet"
          hide-details
          outlined
          maxlength="25"
        />
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex sm6>
        <v-textarea
          v-model="form.footrest_module.comment"
          filled
          name="Ajouter un commentaire :"
          label="Ajouter un commentaire :"
        />
      </v-flex>

      <v-flex
        column
        sm6
      >
        <div class="content img2">
          <div class="img-container">
            <img src="@/assets/img/schema_siegemoule_9b.svg">
            <v-text-field
              v-model="form.footrest_module.a"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Retour) A') }"
              data-vv-name="(Retour) A"
              outlined
              type="number"
              style="top: 17.1%;left: 38.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.footrest_module.b"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Retour) B') }"
              data-vv-name="(Retour) B"
              outlined
              type="number"
              style="top: 29.2%;left: 85.7%;"
              height="100%"
            />
            <v-text-field
              v-model="form.footrest_module.c"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Retour) C') }"
              data-vv-name="(Retour) C"
              outlined
              type="number"
              style="top: 62.1%;left: 19.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.footrest_module.d"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Retour) D') }"
              data-vv-name="(Retour) D"
              outlined
              type="number"
              style="top: 83.4%;left: 51.2%;"
              height="100%"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MoldedSeatStepEight",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      pedalSegmentModule: "dropdowns/getPedalSegmentOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear footrest fields
    clearFootrestFields() {
      this.form.footrest_module.exist = null;
      this.form.footrest_module.position = null;
      this.form.footrest_module.form = null;
    }
  }
};
</script>

<style lang="scss">
.molded-seat-step-eight {
  .content {
    display: flex;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
    &.img1 {
      .img-container {
        .v-input {
          width: 15.5%;
          height: 26.3%;
        }
      }
    }
    &.img2 {
      .img-container {
        .v-input {
          width: 18.4%;
          height: 13.8%;
          background-color: white;
        }
      }
    }
  }
  .v-textarea {
    height: 100%;
    .v-input__control {
      height: 100%;
      .v-input__slot {
        height: 100%;
      }
    }
  }
}
</style>
